/**
 * LoadingPage Component
 *
 * Minimal full-page loading state with subtle background and animated lamma icon.
 * Used for initial app loading states.
 */

import React from 'react';
import lammaIconUrl from '../../../../assets/icons/lamma-icon.svg';

export const LoadingPage: React.FC = () => {
  return (
    <div className="loading-page-container">
      {/* Centered icon with subtle pulse animation */}
      <div className="loading-icon-wrapper">
        <img
          src={lammaIconUrl}
          alt="Loading"
          className="loading-icon"
        />
      </div>
    </div>
  );
};

export default LoadingPage;
